import { Text } from '@serodigital/ui-components';
import * as React from 'react';
import { Day } from '../../contexts/heatingSchedules';

export function Days({ dayKey, selected }) {
  return (
    // eslint-disable-next-line prefer-template
    <div
      className={`p-4 mr-8 mb-8 h-[40px] w-[40px] text-center justify-end ${
        selected ? 'border rounded-lg border-[#FC9073] border-2' : ''
      }`}
    >
      <Text data-qa="schedule-day" size="small">
        {Day[dayKey]}
      </Text>
    </div>
  );
}
